import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useRouter } from 'next/router';
import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/20/solid';
import { ENV } from 'constants/env';

const VCustomForm = ({ blok }) => {
  const router = useRouter();
  const [marketingConsent, setMarketingConsent] = useState(false);
  const [inputFieldValues, setInputFieldValues] = useState([]);
  const [fieldValues, setFieldValues] = useState([]);
  const [errorIndices, setErrorIndices] = useState([]);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const isFullWidth = blok.items.length === 1;

  useEffect(() => {
    initFields();
  }, []);

  const valid = errorIndices.length === 0 && marketingConsent;

  const validationCheck = (index, item, value) => {
    // Check for required fields
    if (item.isRequired && value <= 0) {
      addError(index);
    }
    // Check for the email pattern
    if (item.type === 'email' && value.length > 0) {
      if (!validEmail(value)) {
        addError(index);
      } else {
        removeError(index);
      }
    } else {
      removeError(index);
    }
    console.log(errorIndices);
  };

  const addError = (index) => {
    if (!errorIndices.includes(index)) {
      setErrorIndices([...errorIndices, index]);
    }
  };

  const removeError = (index) => {
    setErrorIndices(errorIndices.filter((errorIndex) => errorIndex !== index));
  };

  const validEmail = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const submit = async () => {
    if (!valid) return;

    const submittedFields = fieldValues.map((item, index) => ({
      name: item.name,
      value: inputFieldValues && inputFieldValues[index] != null ? String(inputFieldValues[index]) : '',
    }));
    setFieldValues(submittedFields);

    const path = window.location.pathname;
    const pageName = path.split('/').filter(Boolean).pop() || 'home';
    const locale = router.locale || blok.language || undefined;

    try {
      await axios.post(`${ENV.BACKEND_API}/contact-form`, {
        fields: submittedFields,
        pageUri: window.location.href,
        pageName,
        locale,
      });

      if (blok.trackingEventId && global.analytics) {
        const inputValuesObject = {};
        submittedFields.forEach((f) => {
          if (f.value) inputValuesObject[f.name] = f.value;
        });
        global.analytics.track(blok.trackingEventId, {
          ...inputValuesObject,
          currentPath: path,
        });
      }

      setSuccess(true);
    } catch (err) {
      setError(err);
    }
  };

  const updateInputFieldValues = (index, value) => {
    const newValue = [...inputFieldValues]
    newValue[index] = value
    setInputFieldValues(newValue)
  }


  const initFields = () => {
    const initFieldValues = blok.items.map((item, index) => {
      if (item.isRequired) {
        addError(index);
      }

      return {
        name: item.formFieldValue,
        value: '',
      }
    });

    setFieldValues(initFieldValues)
    console.log(errorIndices);
  };

  useEffect(() => {
    initFields();
  }, [blok]);


  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <div className="shadow sm:rounded-md sm:overflow-hidden">
        <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
          {/* Header Start */}
          <div>
            {blok.title && (
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                {blok.title}
              </h3>
            )}
            {blok.subtitle && (
              <p className="mt-1 text-sm text-gray-500">{blok.subtitle}</p>
            )}
          </div>
          <div className="grid grid-cols-4 gap-4 grid-flow-row auto-rows-max">
            {/* Content Start */}
            {blok.items.map((item, index) => (
              <div
                key={item._uid}
                className={`col-span-4 ${!isFullWidth ? "sm:col-span-2" : ""}`}
              >
                {/* Text Field */}
                {item.type === "text" && (
                  <div>
                    <label
                      htmlFor="first-name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {item.label}
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name={fieldValues[index] ? fieldValues[index].name : ""}
                        id="first-name"
                        onChange={(e) => {
                          updateInputFieldValues(index, e.target.value);
                          if (item.isRequired) {
                            validationCheck(index, item, e.target.value);
                          }
                        }}
                        autoComplete="given-name"
                        required={item.isRequired}
                        className="
                          shadow-sm
                          focus:ring-cyan
                          focus:border-cyan
                          block
                          w-full
                          sm:text-sm
                          border-gray-300
                          rounded-md
                        "
                      />
                    </div>
                  </div>
                )}

                {/* Email Field */}
                {item.type === "email" && (
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {item.label}
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm">
                      <input
                        type="text"
                        name={fieldValues[index] ? fieldValues[index].name : ""}
                        id="email"
                        onChange={(e) => {
                          updateInputFieldValues(index, e.target.value);
                          if (item.isRequired) {
                            validationCheck(index, item,e.target.value);
                          }
                        }}
                        required={item.isRequired}
                        className={`
                        block
                        w-full
                        pr-10
                        focus:outline-none
                        ${errorIndices.includes(index)
                            ? "focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                            : "focus:ring-cyan focus:border-cyan border-cyan-light text-cyan placeholder-cyan-light"
                          }
                        sm:text-sm
                        rounded-md
                      `}
                        placeholder="you@example.com"
                        aria-invalid="true"
                        aria-describedby="email-error"
                      />
                      {errorIndices.includes(index) && (
                        <div
                          className="
                          absolute
                          inset-y-0
                          right-0
                          pr-3
                          flex
                          items-center
                          pointer-events-none                    "
                        >
                          <ExclamationCircleIcon
                            className="h-5 w-5 text-red-500"
                            aria-hidden="true"
                          />
                        </div>
                      )}
                    </div>
                    {item.hint && (
                      <p
                        className="mt-2 text-sm text-red-600"
                        id="email-error"
                      >
                        {item.hint}
                      </p>
                    )}
                  </div>
                )}

                {/* Dropdown Field */}
                {item.type === "dropdown" && item.options && item.options.length && (
                  <div>
                    <label
                      htmlFor="selection"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {item.label}
                    </label>
                    <div className="mt-1">
                      <select
                        id="selection"
                        name={fieldValues[index] ? fieldValues[index].name : ""}
                        onChange={(e) => {
                          updateInputFieldValues(index, e.target.value);
                          if (item.isRequired) {
                            validationCheck(index, item,e.target.value);
                          }
                        }}
                        autoComplete="selection"
                        required={item.isRequired}
                        className="
                            shadow-sm
                            focus:ring-cyan
                            focus:border-cyan
                            block
                            w-full
                            sm:text-sm
                            border-gray-300
                            rounded-md
                          "
                      >
                        {item.options.map((option) => (
                          <option key={option}>{option}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {/* Text Area Field */}
                {item.type === "textarea" && (
                  <div>
                    <label
                      htmlFor="about"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {item.label}
                    </label>
                    <div className="mt-1">
                      <textarea
                        id="about"
                        name={fieldValues[index] ? fieldValues[index].name : ""}
                        onChange={(e) => {
                          updateInputFieldValues(index, e.target.value);
                          if (item.isRequired) {
                            validationCheck(index, item,e.target.value);
                          }
                        }}
                        required={item.isRequired}
                        className="
                            shadow-sm
                            focus:ring-cyan
                            focus:border-cyan
                            block
                            w-full
                            sm:text-sm
                            border border-gray-300
                            rounded-md
                          "
                        placeholder="you@example.com"
                      />
                    </div>
                    {item.hint && (
                      <p className="mt-2 text-sm text-gray-500">
                        {item.hint}
                      </p>
                    )}
                  </div>
                )}

                {/* Checkbox Field */}
                {item.type === "checkboxes" &&
                  item.options &&
                  item.options.length && (
                    <div className="pt-8">
                      <div className="relative flex items-center">
                        <div className="flex items-center h-5">
                          <input
                            id="comments"
                            checked={inputFieldValues[index]}
                            onChange={(e) => {
                              updateInputFieldValues(index, e.target.checked);
                              if (item.isRequired) {
                                validationCheck(index, item, e.target.value);
                              }
                            }}
                            aria-describedby="comments-description"
                            name={
                              fieldValues[index] ? fieldValues[index].name : ""
                            }
                            type="checkbox"
                            required={item.isRequired}
                            className="
                                focus:ring-cyan
                                h-4
                                w-4
                                text-indigo-600
                                border-gray-300
                                rounded
                              "
                          />
                        </div>
                        <div className="ml-3 text-sm">
                          <label htmlFor="comments" className="font-medium text-gray-700">
                            {item.label}
                          </label>
                          {item.hint && (
                            <span
                              id="comments-description"
                              className="text-gray-500"
                            >
                              {item.hint}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            ))}
          </div>
          <div className="mt-6 grid grid-cols-1">
            {/* Marketing Consent, always required */}
            <div>
              <div className="relative flex items-start">
                <div className="flex items-center h-5">
                  <input
                    id="concent"
                    checked={marketingConsent}
                    onChange={(e) => setMarketingConsent(e.target.checked)}
                    aria-describedby="marketing-consent"
                    name="marketingConsense"
                    type="checkbox"
                    className="
                    focus:ring-cyan
                    h-4
                    w-4
                    text-cyan-dark
                    border-cyan
                    rounded
                    "
                  />
                </div>
                <div className="ml-3 text-sm">
                  <label htmlFor="concent" className="font-medium text-gray-700">
                    {blok.marketingConsentCheckText}
                  </label>
                  <p id="marketing-consent" className="text-gray-500">
                    {blok.marketingConsentText}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
          {success && (
            <div className="rounded-md p-4">
              <div className="flex">
                <div className="flex-shrink-0">
                  <CheckCircleIcon
                    className="h-5 w-5 text-green-400"
                    aria-hidden="true"
                  />
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-green-800">
                    All Good! 🎉
                  </p>
                </div>
              </div>
            </div>
          )}
          {error && (
            <div className="rounded-md p-4">
              <div className="flex">
                <div className="flex-shrink-0">
                  <ExclamationCircleIcon
                    className="h-5 w-5 text-red-400"
                    aria-hidden="true"
                  />
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-red-800">
                    Oh no 🥲
                  </p>
                </div>
              </div>
            </div>
          )}
          {/* Submit Button */}
          {!error && !success && (
            <button
              type="submit"
              disabled={!valid}
              className={`${valid ? "bg-amber" : "bg-gray-400"} border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium ${valid ? "text-grey" : "text-grey-100"} ${valid ? "hover:bg-amber-dark" : "hover:bg-gray-400"} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-dark `}
            >
              {blok.buttonLabel}
            </button>
          )}
        </div>
      </div>
    </form>
  );
}

export default VCustomForm;


